<template>
    <ComboboxGroup
        v-bind="forwarded"
        :class="cn('ds-combobox-group', props.class)"
    >
        <slot />
    </ComboboxGroup>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { ComboboxGroupProps } from 'reka-ui';
import { ComboboxGroup, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<ComboboxGroupProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardProps(delegatedProps);
</script>
